import React from "react";
import { Table, message, Card, Avatar, Typography, Tag } from "antd";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { UserOutlined } from "@ant-design/icons";
import useServerPagination from "Common/hooks/useServerPagination";

const { Text } = Typography;

// Fetch a page of managers from the paginated backend list API.
const fetchManagers = async ({ pageNumber, pageSize, orderByLatest }) => {
  const token = localStorage.getItem("token");
  const qs = new URLSearchParams({ pageNumber, pageSize, orderByLatest }).toString();
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/Manager/GetListAll?${qs}`,
    {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch managers");
  }

  return response.json();
};

const ManagersList = () => {
  const { items, loading, paginationProps } = useServerPagination(fetchManagers, {}, {
    onError: () => message.error("Failed to load managers data"),
  });

  const columns = [
    {
      title: "Manager",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            src={record.profileImage ? `${baseImageUrl}${record.profileImage}` : null}
            icon={!record.profileImage && <UserOutlined />}
            size="large"
            style={{
              backgroundColor: record.profileImage ? "transparent" : "#B17F14",
            }}
          />
          <div>
            <Text strong>
              {record.firstName} {record.lastName}
            </Text>
            <br />
            <Text type="secondary">{record.email}</Text>
          </div>
        </div>
      ),
    },
    {
      title: "Contact",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Business Group",
      dataIndex: "businessGroupName",
      key: "businessGroupName",
      render: (text, record) =>
        record.hasBusinessGroup ? (
          <Tag color="gold">{text}</Tag>
        ) : (
          <Tag color="default">Not assigned</Tag>
        ),
    },
    {
      title: "Profile Status",
      dataIndex: "isProfileDetailCompleted",
      key: "isProfileDetailCompleted",
      render: (completed) => (
        <Tag color={completed ? "green" : "orange"}>{completed ? "Completed" : "Incomplete"}</Tag>
      ),
    },
    {
      title: "Date Joined",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  return (
    <Card className="card-professional" title="Managers List" variant="borderless">
      <Table
        columns={columns}
        dataSource={items}
        rowKey="managerId"
        loading={loading}
        pagination={paginationProps}
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default ManagersList;
